import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry && !original.url.endsWith("/auth/login") && !original.url.endsWith("/auth/refresh")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export default api;

/**
 * Estrae un messaggio leggibile dall'errore axios.
 * Gestisce: stringhe, oggetti singoli, array Pydantic v2 [{type,loc,msg,input,ctx}], errori di rete.
 * NON restituisce mai un oggetto — sempre una stringa sicura da renderizzare.
 */
export function errorMessage(err, fallback = "Errore") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => {
      if (typeof e === "string") return e;
      const field = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
      const msg = e?.msg || e?.message || "campo non valido";
      return field ? `${field}: ${msg}` : msg;
    }).join(" · ");
  }
  if (typeof d === "object") return d.msg || d.message || JSON.stringify(d);
  return fallback;
}
